export interface Movie {
  id: number;
  title: string;
  englishTitle: string;
  category: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  tags: string[];
  imageUrl: string;
  isNew: boolean;
  isHot: boolean;
}

export const categories = [
  { key: 'all', name: '全部', icon: 'ri-movie-line' },
  { key: 'action', name: '动作片', icon: 'ri-fire-line' },
  { key: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { key: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { key: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { key: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { key: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { key: 'animation', name: '动漫', icon: 'ri-palette-line' },
  { key: 'variety', name: '综艺', icon: 'ri-tv-line' },
  { key: 'tv', name: '电视剧', icon: 'ri-tv-2-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: 'scifi',
    year: 2026,
    rating: 8.9,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代将肩负起拯救人类的重任，展开一场横跨星际的壮丽冒险。本片作为系列终章，将揭示人类文明在宇宙中的终极命运，特效场面震撼人心，情感内核深刻动人。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '王智'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['科幻', '冒险', '灾难', '国产大片'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20movie%20poster%20with%20massive%20planet%20engines%20on%20Earth%20surface%20dramatic%20cosmic%20lighting%20epic%20scale%20cinematic%20film%20poster%20design%20warm%20orange%20and%20gold%20accents%20on%20dark%20background&width=400&height=560&seq=movie-wandering-earth-3&orientation=portrait',
    isNew: true,
    isHot: true,
  },
  {
    id: 2,
    title: '满江红',
    englishTitle: 'Full River Red',
    category: 'drama',
    year: 2023,
    rating: 8.2,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇凶案牵扯出惊天秘密，小兵张大与亲兵营副统领孙均被裹挟进这场巨大的阴谋之中，在层层反转中追寻真相。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    region: '中国大陆',
    tags: ['悬疑', '历史', '喜剧', '古装'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20drama%20movie%20poster%20Song%20dynasty%20palace%20courtyard%20dramatic%20red%20and%20black%20color%20scheme%20mysterious%20atmosphere%20cinematic%20film%20poster%20design%20deep%20shadows&width=400&height=560&seq=movie-full-river-red&orientation=portrait',
    isNew: false,
    isHot: true,
  },
  {
    id: 3,
    title: '封神第二部：战火西岐',
    englishTitle: 'Creation of the Gods II',
    category: 'action',
    year: 2025,
    rating: 8.5,
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐西岐武王伐纣。阐教与截教两大阵营展开惊天对决，各路神仙斗法，神魔大战一触即发。精彩的视觉特效与宏大的战争场面，将中国神话史诗推向新高度。',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '146分钟',
    region: '中国大陆',
    tags: ['奇幻', '神话', '动作', '史诗'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20fantasy%20movie%20poster%20ancient%20gods%20and%20warriors%20battle%20scene%20dramatic%20golden%20and%20crimson%20tones%20cinematic%20film%20poster%20with%20divine%20lighting&width=400&height=560&seq=movie-creation-gods-2&orientation=portrait',
    isNew: true,
    isHot: true,
  },
  {
    id: 4,
    title: '热辣滚烫',
    englishTitle: 'YOLO',
    category: 'comedy',
    year: 2024,
    rating: 7.8,
    description: '乐莹是一个善良的女孩，却在生活中处处碰壁。一次偶然的机会让她接触到拳击运动，从此人生发生了翻天覆地的变化。她决定为自己而活，在拳击台上找到属于自己的光芒与力量。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    duration: '129分钟',
    region: '中国大陆',
    tags: ['喜剧', '励志', '运动', '温情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20comedy%20movie%20poster%20woman%20boxing%20training%20scene%20warm%20lighting%20motivational%20atmosphere%20soft%20pink%20and%20golden%20tones%20cinematic%20film%20poster%20design&width=400&height=560&seq=movie-yolo&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 5,
    title: '奥本海默',
    englishTitle: 'Oppenheimer',
    category: 'drama',
    year: 2023,
    rating: 8.8,
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默主导研制世界上第一颗原子弹的故事。影片深入探索了这位复杂人物的内心世界，从曼哈顿计划的辉煌到战后遭受的政治迫害，展现了一个天才科学家在历史洪流中的挣扎与反思。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国',
    tags: ['传记', '历史', '战争', '剧情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20biopic%20drama%20movie%20poster%20nuclear%20explosion%20silhouette%20intense%20dramatic%20lighting%20black%20and%20white%20with%20orange%20fire%20accents%20cinematic%20film%20poster%20design%20solemn%20atmosphere&width=400&height=560&seq=movie-oppenheimer&orientation=portrait',
    isNew: false,
    isHot: true,
  },
  {
    id: 6,
    title: '铃芽之旅',
    englishTitle: 'Suzume',
    category: 'animation',
    year: 2023,
    rating: 8.3,
    description: '生活在九州乡村的17岁少女铃芽，遇见了一名正在寻找"门"的青年。她追随着青年来到山中废墟，发现了一扇古老的门。从此，日本各地开始出现灾难之门，铃芽踏上了关闭这些门的冒险旅程。',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里', '染谷将太'],
    duration: '122分钟',
    region: '日本',
    tags: ['动画', '奇幻', '冒险', '治愈'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20young%20girl%20standing%20before%20mysterious%20ancient%20door%20in%20ruins%20beautiful%20sky%20and%20clouds%20soft%20pastel%20colors%20cinematic%20anime%20film%20poster%20magical%20atmosphere&width=400&height=560&seq=movie-suzume&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 7,
    title: '孤注一掷',
    englishTitle: 'No More Bets',
    category: 'drama',
    year: 2023,
    rating: 8.1,
    description: '程序员潘生和模特安娜被高薪招聘所诱惑，前往海外工作，却意外卷入了一场精心策划的网络诈骗陷阱。他们在异国他乡经历了种种磨难，最终凭借智慧和勇气，展开了一场惊心动魄的逃亡之路。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    duration: '130分钟',
    region: '中国大陆',
    tags: ['犯罪', '剧情', '悬疑', '现实题材'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20dark%20basement%20with%20computer%20screens%20mysterious%20atmosphere%20red%20and%20dark%20tones%20cinematic%20film%20poster%20design%20suspenseful%20mood%20intense%20shadows&width=400&height=560&seq=movie-no-more-bets&orientation=portrait',
    isNew: false,
    isHot: true,
  },
  {
    id: 8,
    title: '蜘蛛侠：纵横宇宙',
    englishTitle: 'Spider-Man: Across the Spider-Verse',
    category: 'animation',
    year: 2023,
    rating: 8.7,
    description: '迈尔斯·莫拉莱斯踏上全新的多元宇宙冒险之旅，与蜘蛛格温重逢，并结识了来自不同维度的蜘蛛侠联盟。面对前所未有的威胁，迈尔斯必须重新定义什么是英雄，独自踏上拯救所爱之人的旅程。',
    director: '乔伊姆·多斯·桑托斯',
    cast: ['沙梅克·摩尔', '海莉·斯坦菲尔德', '奥斯卡·伊萨克'],
    duration: '140分钟',
    region: '美国',
    tags: ['动画', '超级英雄', '冒险', '多元宇宙'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Animated%20superhero%20movie%20poster%20multiple%20spider%20man%20variants%20swinging%20through%20colorful%20multiverse%20city%20vibrant%20comic%20book%20art%20style%20dynamic%20action%20cinematic%20animation%20poster&width=400&height=560&seq=movie-spider-verse&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 9,
    title: '消失的她',
    englishTitle: 'Lost in the Stars',
    category: 'horror',
    year: 2023,
    rating: 7.9,
    description: '丈夫何非的妻子在海外度假时神秘失踪，当他苦寻无果之际，一个陌生女人突然出现并声称自己就是他的妻子。在真相与谎言交织的迷局中，一场关于爱情、欺骗与复仇的悬疑大戏拉开帷幕。',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '122分钟',
    region: '中国大陆',
    tags: ['悬疑', '犯罪', '惊悚', '反转'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20tropical%20island%20at%20night%20dark%20ocean%20waves%20suspenseful%20atmosphere%20deep%20blue%20and%20black%20tones%20cinematic%20film%20poster%20design%20mysterious%20mood&width=400&height=560&seq=movie-lost-stars&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 10,
    title: '长安三万里',
    englishTitle: 'Chang An',
    category: 'animation',
    year: 2023,
    rating: 8.6,
    description: '安史之乱后数年，吐蕃大军入侵西南，困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以壮丽的盛唐气象为背景，展现了大唐诗人们波澜壮阔的人生画卷与不朽的诗篇。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    region: '中国大陆',
    tags: ['动画', '历史', '文化', '唐诗'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20Tang%20dynasty%20ancient%20capital%20city%20Chang%20An%20golden%20palace%20architecture%20warm%20golden%20and%20crimson%20color%20palette%20cinematic%20animation%20film%20poster&width=400&height=560&seq=movie-chang-an&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 11,
    title: '志愿军：雄兵出击',
    englishTitle: 'The Volunteers: To the War',
    category: 'action',
    year: 2023,
    rating: 8.0,
    description: '1949年新中国成立初期，百废待兴。面对朝鲜战争的爆发，中国人民志愿军毅然跨过鸭绿江，保家卫国。影片全景式展现了抗美援朝战争的恢弘史诗，致敬最可爱的人。',
    director: '陈凯歌',
    cast: ['唐国强', '王砚辉', '刘劲', '辛柏青', '张颂文'],
    duration: '140分钟',
    region: '中国大陆',
    tags: ['战争', '历史', '主旋律', '爱国'],
    imageUrl: 'https://readdy.ai/api/search-image?query=War%20epic%20movie%20poster%20soldiers%20marching%20through%20snowy%20mountain%20battlefield%20dramatic%20winter%20lighting%20muted%20olive%20and%20gray%20tones%20cinematic%20film%20poster%20design%20heroic%20atmosphere&width=400&height=560&seq=movie-volunteers&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 12,
    title: '你想活出怎样的人生',
    englishTitle: 'The Boy and the Heron',
    category: 'animation',
    year: 2024,
    rating: 8.4,
    description: '少年牧真人在母亲去世后，随父亲搬到乡下生活。一只会说话的苍鹭将他引入一座神秘的塔楼，在那里他进入了一个奇幻的生与死的世界。宫崎骏导演暌违十年的回归之作，充满了对生命意义的深邃思考。',
    director: '宫崎骏',
    cast: ['山时聪真', '菅田将晖', '柴咲幸', '木村拓哉'],
    duration: '124分钟',
    region: '日本',
    tags: ['动画', '奇幻', '冒险', '成长'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20anime%20movie%20poster%20boy%20with%20mysterious%20heron%20bird%20in%20magical%20tower%20surreal%20dreamlike%20atmosphere%20soft%20watercolor%20textures%20cinematic%20anime%20poster%20design&width=400&height=560&seq=movie-boy-heron&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 13,
    title: '年会不能停！',
    englishTitle: 'Johnny Keep Walking!',
    category: 'comedy',
    year: 2024,
    rating: 8.3,
    description: '钳工胡建林阴差阳错被调入集团总部，从一个工厂工人变成了总部白领。面对光怪陆离的职场文化和复杂的办公室政治，他用自己质朴的方式闯出了一片天地，引发了一连串啼笑皆非的故事。',
    director: '董润年',
    cast: ['大鹏', '白客', '庄达菲', '王迅', '孙艺洲'],
    duration: '117分钟',
    region: '中国大陆',
    tags: ['喜剧', '职场', '讽刺', '温情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20modern%20office%20setting%20with%20colorful%20festive%20decorations%20bright%20warm%20lighting%20humorous%20atmosphere%20cinematic%20film%20poster%20design&width=400&height=560&seq=movie-johnny-keep&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 14,
    title: '人生大事',
    englishTitle: 'Lighting Up The Stars',
    category: 'drama',
    year: 2022,
    rating: 8.5,
    description: '殡葬师莫三妹遇到了孤儿武小文，两个看似毫不相关的人却因为命运的安排走到了一起。在相互陪伴的日子里，他们共同经历了人生的喜怒哀乐，见证了生命的无常与美好。',
    director: '刘江江',
    cast: ['朱一龙', '杨恩又', '王戈', '刘陆'],
    duration: '112分钟',
    region: '中国大陆',
    tags: ['剧情', '家庭', '温情', '治愈'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20drama%20movie%20poster%20man%20and%20little%20girl%20under%20starry%20night%20sky%20warm%20emotional%20lighting%20soft%20golden%20tones%20cinematic%20film%20poster%20design%20touching%20atmosphere&width=400&height=560&seq=movie-lighting-stars&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 15,
    title: '复仇者联盟4：终局之战',
    englishTitle: 'Avengers: Endgame',
    category: 'action',
    year: 2019,
    rating: 8.5,
    description: '在灭霸打了响指毁灭了宇宙一半生命的阴影下，幸存的复仇者联盟成员必须再次集结，通过量子领域穿越时空，收集无限宝石，来逆转灭霸造成的毁灭性后果，为宇宙恢复秩序。',
    director: '安东尼·罗素',
    cast: ['小罗伯特·唐尼', '克里斯·埃文斯', '斯嘉丽·约翰逊', '克里斯·海姆斯沃斯'],
    duration: '181分钟',
    region: '美国',
    tags: ['超级英雄', '科幻', '动作', '史诗'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Superhero%20team%20movie%20poster%20avengers%20assembled%20in%20epic%20battle%20pose%20dramatic%20lighting%20purple%20and%20gold%20cosmic%20background%20cinematic%20film%20poster%20design%20heroic%20atmosphere&width=400&height=560&seq=movie-endgame&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 16,
    title: '你好，李焕英',
    englishTitle: 'Hi, Mom',
    category: 'comedy',
    year: 2021,
    rating: 8.1,
    description: '2001年的某一天，刚考上大学的贾晓玲经历了一次人生的大起大落。在情绪崩溃的状态下，她意外穿越到了1981年，并与年轻的母亲李焕英相遇，两人形影不离，成为了亲密无间的好闺蜜。',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫'],
    duration: '128分钟',
    region: '中国大陆',
    tags: ['喜剧', '亲情', '穿越', '温情'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20comedy%20movie%20poster%201980s%20retro%20China%20mother%20and%20daughter%20smiling%20warm%20vintage%20lighting%20soft%20yellow%20and%20cream%20tones%20cinematic%20film%20poster%20design&width=400&height=560&seq=movie-hi-mom&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 17,
    title: '星际穿越',
    englishTitle: 'Interstellar',
    category: 'scifi',
    year: 2014,
    rating: 9.3,
    description: '在不久的将来，地球环境急剧恶化。前NASA宇航员库珀被选中参与一项穿越虫洞的星际旅行计划，为人类寻找新的宜居星球。面对浩瀚宇宙与时空扭曲，他必须在拯救人类与回到女儿身边之间做出选择。',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    duration: '169分钟',
    region: '美国',
    tags: ['科幻', '冒险', '亲情', '硬科幻'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Space%20exploration%20sci%20fi%20movie%20poster%20astronaut%20standing%20before%20giant%20wormhole%20in%20deep%20space%20dramatic%20cosmic%20lighting%20deep%20black%20and%20golden%20tones%20cinematic%20film%20poster&width=400&height=560&seq=movie-interstellar&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 18,
    title: '周处除三害',
    englishTitle: 'The Pig, the Snake and the Pigeon',
    category: 'action',
    year: 2024,
    rating: 8.4,
    description: '通缉犯陈桂林被告知自己已是肺癌晚期，命不久矣。他决定在死前干一件大事——除掉排在自己前面的两个通缉犯，成为世人皆知的"周处"。一场荒诞又悲壮的自我救赎之旅由此展开。',
    director: '黄精甫',
    cast: ['阮经天', '袁富华', '陈以文', '王净'],
    duration: '134分钟',
    region: '中国台湾',
    tags: ['动作', '犯罪', '黑色幽默', '人性'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Taiwanese%20crime%20action%20movie%20poster%20man%20in%20dark%20alley%20neon%20lights%20gritty%20atmosphere%20intense%20shadows%20dark%20green%20and%20amber%20tones%20cinematic%20film%20poster%20design&width=400&height=560&seq=movie-pig-snake-pigeon&orientation=portrait',
    isNew: true,
    isHot: true,
  },
  {
    id: 19,
    title: '第二十条',
    englishTitle: 'Article 20',
    category: 'drama',
    year: 2024,
    rating: 8.2,
    description: '围绕《刑法》第二十条"正当防卫"条款，讲述了检察官韩明在处理一起棘手的正当防卫案件时，面对舆论压力、人情世故与法律正义的艰难抉择，最终坚守法治信仰的故事。',
    director: '张艺谋',
    cast: ['雷佳音', '马丽', '赵丽颖', '高叶', '刘耀文'],
    duration: '141分钟',
    region: '中国大陆',
    tags: ['剧情', '法律', '社会', '现实'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20courtroom%20scene%20with%20dramatic%20lighting%20solemn%20atmosphere%20deep%20blue%20and%20warm%20wood%20tones%20cinematic%20film%20poster%20design&width=400&height=560&seq=movie-article-20&orientation=portrait',
    isNew: true,
    isHot: false,
  },
  {
    id: 20,
    title: '芭比',
    englishTitle: 'Barbie',
    category: 'comedy',
    year: 2023,
    rating: 7.5,
    description: '生活在完美芭比乐园中的经典芭比，突然开始思考死亡的意义。她的完美生活出现裂痕，不得不前往现实世界寻找答案。一场关于女性主义、自我认同与存在意义的粉红色冒险就此展开。',
    director: '格蕾塔·葛韦格',
    cast: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉', '凯特·麦金农'],
    duration: '114分钟',
    region: '美国',
    tags: ['喜剧', '奇幻', '女性', '讽刺'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Barbie%20movie%20poster%20pink%20dreamhouse%20aesthetic%20vibrant%20saturated%20pink%20color%20palette%20playful%20cinematic%20film%20poster%20design%20whimsical%20atmosphere%20glamorous%20lighting&width=400&height=560&seq=movie-barbie&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 21,
    title: '一闪一闪亮星星',
    englishTitle: 'Shining For One Thing',
    category: 'romance',
    year: 2023,
    rating: 7.6,
    description: '林北星即将步入婚礼殿堂，却因一场意外回到了高中时代。在那里，她遇到了让她的青春充满色彩的张万森。跨越时空的爱恋，一段关于青春、记忆与选择的动人故事。',
    director: '陈小明',
    cast: ['张佳宁', '屈楚萧', '傅菁', '蒋昀霖'],
    duration: '107分钟',
    region: '中国大陆',
    tags: ['爱情', '奇幻', '青春', '穿越'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20movie%20poster%20young%20couple%20under%20starry%20night%20sky%20dreamy%20soft%20pastel%20colors%20cinematic%20film%20poster%20design%20nostalgic%20atmosphere%20gentle%20lighting&width=400&height=560&seq=movie-shining-star&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 22,
    title: '异形：夺命舰',
    englishTitle: 'Alien: Romulus',
    category: 'horror',
    year: 2024,
    rating: 7.8,
    description: '一群年轻的太空殖民者在废弃的空间站深处探索时，意外遭遇了宇宙中最可怕的生物——异形。在封闭的空间站中，他们必须与这个完美的猎杀者展开一场惊心动魄的生死较量。',
    director: '费德·阿尔瓦雷兹',
    cast: ['卡莉·史派妮', '伊莎贝拉·默塞德', '大卫·约翰松'],
    duration: '119分钟',
    region: '美国',
    tags: ['恐怖', '科幻', '惊悚', '太空'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci%20fi%20horror%20movie%20poster%20dark%20abandoned%20space%20station%20corridor%20menacing%20alien%20silhouette%20cold%20blue%20lighting%20cinematic%20film%20poster%20design%20tense%20atmosphere%20deep%20shadows&width=400&height=560&seq=movie-alien-romulus&orientation=portrait',
    isNew: true,
    isHot: false,
  },
  {
    id: 23,
    title: '飞驰人生2',
    englishTitle: 'Pegasus 2',
    category: 'comedy',
    year: 2024,
    rating: 8.0,
    description: '曾经的拉力赛车手张驰在经历了人生的低谷后，决定重返赛道。面对新的挑战和更强大的对手，他与老搭档和新伙伴一起，再次踏上追逐赛车梦想的征途。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    duration: '129分钟',
    region: '中国大陆',
    tags: ['喜剧', '运动', '赛车', '励志'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20rally%20car%20speeding%20on%20desert%20highway%20dust%20and%20sunset%20warm%20golden%20lighting%20cinematic%20film%20poster%20design%20action%20atmosphere&width=400&height=560&seq=movie-pegasus-2&orientation=portrait',
    isNew: false,
    isHot: false,
  },
  {
    id: 24,
    title: '毒液3：最后一舞',
    englishTitle: 'Venom: The Last Dance',
    category: 'action',
    year: 2024,
    rating: 7.2,
    description: '埃迪·布洛克和毒液共生体继续他们的逃亡生涯，同时被来自人类世界和共生体母星的双重追杀。在这场关乎生死存亡的终极对决中，他们将做出最后的抉择。',
    director: '凯莉·马塞尔',
    cast: ['汤姆·哈迪', '朱诺·坦普尔', '切瓦特·埃加福特'],
    duration: '110分钟',
    region: '美国',
    tags: ['动作', '科幻', '超级英雄', '共生体'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Superhero%20action%20movie%20poster%20venom%20symbiote%20dark%20liquid%20form%20menacing%20presence%20black%20and%20crimson%20color%20scheme%20cinematic%20film%20poster%20design%20intense%20atmosphere&width=400&height=560&seq=movie-venom-3&orientation=portrait',
    isNew: true,
    isHot: false,
  },
];

export const newEpisodes = [
  { id: 101, title: '庆余年 第二季', episode: '第36集（大结局）', category: 'tv', rating: 8.9, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20TV%20series%20poster%20ancient%20Chinese%20palace%20setting%20dramatic%20lighting%20golden%20and%20crimson%20tones%20cinematic%20TV%20show%20poster%20design&width=400&height=560&seq=tv-joy-life-2&orientation=portrait' },
  { id: 102, title: '与凤行', episode: '第39集（大结局）', category: 'tv', rating: 8.3, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20TV%20poster%20phoenix%20motif%20ancient%20goddess%20elegant%20flowing%20robes%20soft%20ethereal%20lighting%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-legend-shenli&orientation=portrait' },
  { id: 103, title: '玫瑰的故事', episode: '第38集（大结局）', category: 'tv', rating: 8.1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20romance%20drama%20TV%20poster%20elegant%20woman%20with%20roses%20warm%20romantic%20lighting%20soft%20pink%20and%20cream%20tones%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-rose-story&orientation=portrait' },
  { id: 104, title: '墨雨云间', episode: '第40集（大结局）', category: 'tv', rating: 8.0, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20TV%20poster%20rainy%20ancient%20Chinese%20courtyard%20ink%20wash%20painting%20style%20moody%20atmosphere%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-moyu-yunjian&orientation=portrait' },
  { id: 105, title: '长相思 第二季', episode: '第23集（大结局）', category: 'tv', rating: 8.5, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20TV%20poster%20couple%20in%20ancient%20robes%20under%20moonlight%20dreamy%20ethereal%20atmosphere%20cinematic%20TV%20show%20poster%20design&width=400&height=560&seq=tv-lost-you-forever-2&orientation=portrait' },
  { id: 106, title: '唐朝诡事录之西行', episode: '第40集（大结局）', category: 'tv', rating: 8.4, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20Tang%20dynasty%20mystery%20drama%20TV%20poster%20desert%20caravan%20ancient%20silk%20road%20mysterious%20atmosphere%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-tang-mystery-west&orientation=portrait' },
  { id: 107, title: '大奉打更人', episode: '第40集（大结局）', category: 'tv', rating: 8.2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20investigation%20drama%20TV%20poster%20night%20watchman%20in%20ancient%20Chinese%20city%20dark%20mysterious%20atmosphere%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-dafeng-nightwatch&orientation=portrait' },
  { id: 108, title: '狐妖小红娘·月红篇', episode: '第36集（大结局）', category: 'tv', rating: 7.8, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20TV%20poster%20fox%20spirit%20matchmaker%20beautiful%20ancient%20Chinese%20aesthetic%20crimson%20and%20gold%20tones%20cinematic%20TV%20show%20poster&width=400&height=560&seq=tv-fox-spirit&orientation=portrait' },
];

export const heroMovies: Movie[] = [
  movies[0],
  movies[2],
  movies[1],
  movies[4],
  movies[17],
];

export const siteInfo = {
  name: '7777影院',
  englishName: '7777 Cinema',
  slogan: '高清影视，畅享无限',
  description: '7777影院（777777影院）是国内领先的免费高清影视在线观看平台，致力于为广大影迷提供最新、最全的电影、电视剧、综艺、动漫等视频资源。我们拥有海量正版高清内容，支持流畅播放不卡顿，每日同步更新全网最新剧集，让您随时随地享受影院级观影体验。',
  founded: '2020年',
  email: 'contact@7777yingyuan.com',
  address: '北京市朝阳区影视文化产业园A座',
  phone: '400-7777-888',
  stats: [
    { label: '影视资源', value: '100,000+' },
    { label: '日均访问', value: '500万+' },
    { label: '注册用户', value: '2,000万+' },
    { label: '合作版权', value: '3,000+' },
  ],
  features: [
    { title: '海量片库', description: '涵盖电影、电视剧、综艺、动漫等数十万部资源，每日实时更新最新内容。', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '支持1080P、4K超清画质播放，带来影院级沉浸式观影体验。', icon: 'ri-4k-line' },
    { title: '流畅不卡', description: '全球CDN加速节点，自适应码率技术，确保播放流畅不缓冲。', icon: 'ri-speed-up-line' },
    { title: '多端同步', description: '支持PC、平板、手机等多终端观看，观影记录云端同步。', icon: 'ri-device-line' },
    { title: '智能推荐', description: '基于AI算法精准推荐，帮你发现更多符合口味的好片。', icon: 'ri-brain-line' },
    { title: '完全免费', description: '所有内容免费观看，无需付费订阅，让每个人都能享受影视乐趣。', icon: 'ri-vip-crown-line' },
  ],
  faqs: [
    { question: '7777影院是否需要注册才能观看？', answer: '不需要注册。7777影院所有内容完全免费，无需注册或登录即可直接观看，真正做到无障碍观影体验。' },
    { question: '7777影院的视频画质如何？', answer: '7777影院提供多种画质选择，包括标清、高清720P、超清1080P以及部分影片支持4K画质，您可以根据网络情况自由切换。' },
    { question: '观看视频卡顿怎么办？', answer: '7777影院采用全球CDN加速和自适应码率技术。如果出现卡顿，建议您切换较低画质，或检查本地网络状况。我们的服务器集群确保在高峰期也能保持流畅播放。' },
    { question: '7777影院的影片更新频率如何？', answer: '7777影院每日同步更新最新电影和电视剧资源。热门剧集通常在播出后2小时内上线，电影资源在院线下映后第一时间更新，确保您永远不落后于追剧进度。' },
    { question: '7777影院支持哪些设备观看？', answer: '7777影院全面支持PC电脑、平板电脑、智能手机等各类设备。网页采用响应式设计，自动适配不同屏幕尺寸，无论在家还是外出都能享受流畅观影体验。' },
    { question: '7777影院的视频资源是否正版？', answer: '7777影院与多家内容提供商建立了合作关系，致力于为正版内容提供传播渠道。我们严格遵守相关法律法规，保护知识产权，为用户提供合法合规的观影服务。' },
  ],
};